module.exports = __webpack_public_path__ + "static/media/ic-alert.ce589575.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/peterpan/ic-alert.svg
// module id = 799
// module chunks = 0